import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';

import type {
    RemoveCollaboratorMutation,
    RemoveCollaboratorMutationVariables,
} from 'generated/graphql';
import { RemoveCollaboratorDocument } from 'generated/graphql';
import invariant from 'tiny-invariant';

export const REMOVE_BUILD_HUB_COLLABORATOR_API_ROUTE =
    '/remix-api/app/build-hub-collaborator-remove';

const DEFAULT_FAILED_MESSAGE = 'Failed to remove BuildHub collaborator.';

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(data.get('buildHubId'), 'No BuildHub ID provided for removal.');
    invariant(
        data.get('collaboratorId'),
        'No Collaborator ID provided for removal.'
    );

    let variables: RemoveCollaboratorMutationVariables = {
        BuildHubID: data.get('buildHubId') as string,
        CollaboratorID: data.get('collaboratorId') as string,
    };

    try {
        const { data: result } = await context.client.mutate<
            RemoveCollaboratorMutation,
            RemoveCollaboratorMutationVariables
        >({
            mutation: RemoveCollaboratorDocument,
            variables,
        });

        const validResult = result?.buildHubCollaboratorRemove;
        if (!validResult) {
            return json({
                buildHubUpsert: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            buildHubUpsert: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
